import { useEffect } from "react";
import { connect } from "react-redux";
// @material-ui/core components
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
//import custom components
import componentStylesGeneric from "assets/theme/views/admin/generic";
import GenericBackdrop from "components/Backdrops/GenericBackdrop";
import { getOpportunitiesDetailsAction } from "redux/actions/opportunitiesAction";
import OpportunityData from "./OpportunityData";
import RecommendedOpportunities from "./RecommendedOpportunities";

import LocationHeader from "components/Headers/LocationHeader.js";
import PageTitleHeader from "components/Headers/PageTitleHeader.js";

const useStylesGeneric = makeStyles(componentStylesGeneric);
const useStylesLocal = makeStyles((theme) => ({
  containerRootNoHorizontalPadding: {
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "0!important",
      paddingRight: "0!important",
    },
  },
}));

function OpportunityDetails(props) {
  const classes = useStylesGeneric();
  const localClasses = useStylesLocal();

  useEffect(() => {
    if (
      props.opportunitiesState.opportunityDetailsData === undefined ||
      props.opportunitiesState.opportunityDetailsData.opportunityId !==
      props.match.params.opportunityId
    ) {
      props.getOpportunityDetails(props.match.params.opportunityId);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.match.params.opportunityId]);

  return (
    <>
      <GenericBackdrop
        open={props.opportunitiesState.get_opportunity_details_loading}
      />
      <Container
        maxWidth={false}
        component={Box}
        classes={{ root: classes.containerRoot + " " + localClasses.containerRootNoHorizontalPadding }}
      >
        <LocationHeader
          subsection={"Emprego e Estágio Profissional"}
          section={"Detalhes de Oferta"}
          subsectionLink={"/admin/available-opportunities"}
        />

        <PageTitleHeader title={props.opportunitiesState.opportunityDetailsData?.title} wrap small />

        <Box component={Grid} container>
          <Grid item xs={12} xl={3}>
            <RecommendedOpportunities
              pageSize={3}
              fullWidth={true}
              excludeOpportunityId={props.match.params.opportunityId}
            />
          </Grid>
          <Grid item 
            xs={12} 
            xl={9}
          >
            <OpportunityData
              opportunityDetailsData={props.opportunitiesState.opportunityDetailsData}
            />
          </Grid>
        </Box>
      </Container>
    </>
  );
}

const mapStateToProps = (state) => ({ ...state });

const mapDispatchToProps = (dispatch) => ({
  getOpportunityDetails: (opportunityId) =>
    dispatch(getOpportunitiesDetailsAction(opportunityId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(OpportunityDetails);
